import React from 'react';
import Input from '../../../../ui/Input';
import { Plus, Trash2 } from 'lucide-react';

interface Props {
  achievements: string[];
  onUpdate: (achievements: string[]) => void;
}

export default function AchievementList({ achievements, onUpdate }: Props) {
  const addAchievement = () => {
    onUpdate([...achievements, '']);
  };

  const updateAchievement = (index: number, value: string) => {
    const updated = [...achievements];
    updated[index] = value;
    onUpdate(updated);
  };

  const removeAchievement = (index: number) => {
    onUpdate(achievements.filter((_, i) => i !== index));
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Key Achievements
      </label>
      {achievements.map((achievement, index) => (
        <div key={index} className="flex gap-2 mb-2">
          <Input
            value={achievement}
            onChange={(e) => updateAchievement(index, e.target.value)}
            placeholder="Describe a key achievement or responsibility"
            className="flex-1"
          />
          <button
            onClick={() => removeAchievement(index)}
            className="text-red-500 hover:text-red-600"
          >
            <Trash2 className="h-5 w-5" />
          </button>
        </div>
      ))}
      <button
        onClick={addAchievement}
        className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1"
      >
        <Plus className="h-4 w-4" />
        Add Achievement
      </button>
    </div>
  );
}